// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__TsLzL","sendOtp":"AuthorizeToLogin_sendOtp__1fpqV"};